import type { Store, BillingSlotType } from '@/types/Store'
import { Module } from '@/types/Store/StoreEnums'

type CapacityStore = Pick<Store, 'billingStatus' | 'billing'> &
  Partial<Pick<Store, 'hasModule' | 'access' | 'modules'>>

export function isFreeStore(store: CapacityStore | null | undefined): boolean {
  return store?.billingStatus === 6 || store?.billing?.mode === 'free'
}

function capacity(value: number): number {
  return Number.isSafeInteger(value) && value >= 0 ? value : 0
}

export function slotLimit(store: CapacityStore | null | undefined, slot: BillingSlotType): number {
  if (slot === 'fuelTrucks') {
    const enabled = store?.hasModule
      ? store.hasModule(Module.Fueling)
      : (store?.access?.modules?.Fueling ??
        (store?.billing?.entitlements?.modules?.Fueling === true ||
          store?.modules?.some((item) => item.module === Module.Fueling && item.hasAccess) ===
            true))
    return enabled ? capacity(store?.billing?.entitlements?.slots?.fuelTrucks ?? 1) : 0
  }
  return capacity(store?.billing?.entitlements?.slots?.[slot] ?? (slot === 'part141' ? 0 : 1))
}
